module.exports = __webpack_public_path__ + "media/images/emblems/Muri_bei_Bern-coat_of_arms-1d17966d058168cac2e37b4a2477d27f.svg";